module.exports = __webpack_public_path__ + "img/personal-website.3b4209ad.jpg";